import { useLocale } from 'next-intl';
import { localeDir } from '@mentorivo/shared/locales';

/**
 * Yazı yönü — `<html dir>` ile aynı kaynaktan (dil kodu).
 *
 * CSS mantıksal özellikler (`margin-inline-start`, `inset-inline-end`) yönü
 * kendiliğinden izliyor; bu kanca CSS'in ulaşamadığı yerler için: Motion'ın
 * `x` ofsetleri, sürükleme eşikleri, klavye ok tuşları, ölçülen kutudan
 * hesaplanan konumlar.
 */
export function useDirection(): 'ltr' | 'rtl' {
  return localeDir(useLocale());
}

/**
 * Yatay işaret: soldan sağa dilde `1`, sağdan sola dilde `-1`.
 *
 * "Sağdan kayarak gel" hareketi Arapçada "soldan" olmalı — satırın bittiği
 * taraf orası. `x: 24 * sign` yazmak yeter.
 */
export function useInlineSign(): 1 | -1 {
  return useDirection() === 'rtl' ? -1 : 1;
}
